import { TooltipProps } from '@material-ui/core';
import styled from 'styled-components';
import { Tooltip } from 'components/Table/Table.css';

export const TooltipLower = styled(Tooltip)<TooltipProps>`
  &.MuiIconButton-root {
    margin-bottom: -3px;
  }
`;
